import { Telefono } from "../components/telefono/telefono.component";


export interface TipoContacto {
  IdTipoContacto?: number | string;
  tipoContactoDesc?: string;
}
export interface Entidad {
  IdEntidad?: number | string;
  razonSocial?: string;
  paisEntidad?: string;
  localidadEntidad?: string;
  provinciaEntidad?: string;
  clasificacionEntidad?: string;

}

export class Contacto {
  constructor(
    public apellido?: string,
    public cargo?: string,
    //public celular?: string,
    public celularCodigoPais?: string,
    public celularCodigoArea?: string,
    public celularNumero?: string,
    public email?: string,
    public entidad?: Entidad,
    public examen: string = '',
    public fechaAlta: string = '',
    public fechaCertificacion?: string,
    public fechaModificacion?: string,
    public usuarioModificacion?: string,
    public dia_nacimiento?: string,
    public mes_nacimiento?: string,
    public fechaUltimaCertificacion?: string,
    public idContacto?: number | string,
    public interno?: string,
    public kit: string = '',
    public nombre?: string,
    public pago?: string,
    public perfil: string = '',
    public razonSocial?: string,
   // public celular?: string,
    public telefonoCodigoPais?: number,
    public telefonoCodigoArea?: number,
    public telefonoNumero?: number,
    public tipoContacto?: TipoContacto,
    public fechaCreacion: string = '',
  ) {
  }
}
